import AwaitHelper from 'garaje/helpers/await';

export default class extends AwaitHelper {
  compute(params: [Promise<unknown>]): boolean | null {
    const maybePromise = params[0];

    return this.ensureLatestPromise(maybePromise, async (promise: Promise<unknown>) => {
      try {
        await promise;
        this.setValue(true, maybePromise);
      } catch (_err) {
        this.setValue(false, maybePromise);
      }
    }) as boolean | null;
  }
}
